(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.ZonesDropdownTableController = (function(superClass) {
    extend(ZonesDropdownTableController, superClass);

    function ZonesDropdownTableController(scope, transitions, zone_type, option_name, option_type, options, validation, pgis, zones_service) {
      var ref, ref1;
      this.scope = scope;
      this.transitions = transitions;
      this.zone_type = zone_type;
      this.validation = validation;
      this.pgis = pgis;
      this.zones_service = zones_service;
      this.validate = bind(this.validate, this);
      if ((this.pgis.field_data == null) && !this.validation.canContinue()) {
        return;
      }
      this.scope.disabled.back = false;
      this.scope.field_data = ((ref = this.pgis) != null ? ref.field_data : void 0) != null ? this.pgis.field_data : this.validation.getFieldData();
      this.scope.zone = this.scope.field_data.zones[this.zone_type];
      if (((ref1 = this.scope.zone.extra_info) != null ? ref1.mappings : void 0) != null) {
        this.scope.zone.extra_info.mappings = [];
      } else if (this.scope.zone.extra_info == null) {
        this.scope.zone.extra_info = {
          crop: null,
          units: "bu/ac",
          name_add: null,
          mappings: []
        };
      }
      this.scope.zone.zone_type = this.zone_type;
      this.scope.zone_type = this.zone_type;
      this.scope.field_data.visited_settings = true;
      this.scope.validation = this.validation;
      this.scope.validate = this.validate;
      this.scope.validation.setStepScope(this.scope);
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          var i, len, ref2, z;
          if (_this.zone_type === 'irrigation') {
            _this.pgis.setIrrigationZone(_this.scope.zone);
          }
          if (_this.zone_type === 'previous-crop') {
            _this.pgis.setPreviousCropZone(_this.scope.zone);
          }
          if (_this.zone_type === 'productivity') {
            _this.pgis.setProductivityZone(_this.scope.zone);
          }
          if (_.startsWith($transition.to().name, 'grower.fields-define')) {
            _this.scope.died_willingly = true;
          }
          if (_this.scope.zone_type === 'previous-crop') {
            ref2 = _this.scope.zone.zones;
            for (i = 0, len = ref2.length; i < len; i++) {
              z = ref2[i];
              App.map.removeLayer(z.visible);
            }
            _this.pgis.setFieldData(null);
            return _this.pgis.setZoneObject(null);
          }
        };
      })(this));
      this.scope.$parent.steps.once('switch-from', "grower.fields-define." + this.zone_type + "-settings1", (function(_this) {
        return function(data) {
          if (data.is_forward) {
            _this.scope.field_data.visited_settings = null;
            return _this.validation.setFieldData(_this.scope.field_data);
          }
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          if (!_this.scope.died_willingly) {
            _this.validation.clearLayers();
            _this.validation.settings = {};
          }
          return _this.transitionStart();
        };
      })(this));
      this.zones_service.crops().then((function(_this) {
        return function(crops) {
          crops.push({
            name: '---------------',
            id: -1,
            unused: false,
            is_divider: true
          });
          return _this.scope.crops = crops;
        };
      })(this));
      this.pgis.addZonesToMapIfNeeded(this.scope.zone);
      this.scope.validation.validate();
      this.validation.setBackButtonDisable(this.scope.field_data, false);
    }

    ZonesDropdownTableController.prototype.validate = function(ending) {
      var area, i, len, ref;
      this.validation.setFieldData(this.scope.field_data);
      ref = this.scope.zone.zones;
      for (i = 0, len = ref.length; i < len; i++) {
        area = ref[i];
        if (area.value == null) {
          return false;
        }
      }
      return true;
    };

    return ZonesDropdownTableController;

  })(Controller);

}).call(this);
